import { createReducer } from "reduxsauce";

import importer from "common/importer";
const { INITIAL_STATE } = importer("Stores/Users/InitialState", null);
const { UsersTypes } = importer("Stores/Users/Actions", null);

const loginLoading = (state) => ({
  ...state,
  logoutTimeout: false,
  loginLoading: true,
  loginSuccess: null,
  loginFailure: null,
});

const loginSuccess = (state, { res }) => ({
  ...state,
  loginLoading: false,
  loginSuccess: res,
  loginFailure: null,
});

const loginFailure = (state, { error }) => ({
  ...state,
  loginLoading: false,
  loginSuccess: null,
  loginFailure: error,
});

const verifyOktaAccountLoading = (state) => ({
  ...state,
  verifyOktaAccountLoading: true,
  verifyOktaAccountSuccess: null,
  verifyOktaAccountFailure: null,
});

const verifyOktaAccountSuccess = (state, { res }) => ({
  ...state,
  verifyOktaAccountLoading: false,
  verifyOktaAccountSuccess: res,
  verifyOktaAccountFailure: null,
});

const verifyOktaAccountFailure = (state, { error }) => ({
  ...state,
  verifyOktaAccountLoading: false,
  verifyOktaAccountSuccess: null,
  verifyOktaAccountFailure: error,
});

//

const loginAuthLoading = (state) => ({
  ...state,
  loginAuthLoading: true,
  loginAuthSuccess: null,
  loginAuthFailure: null,
});
const loginAuthSuccess = (state, { res }) => ({
  ...state,
  loginAuthLoading: false,
  loginAuthSuccess: res,
  loginAuthFailure: null,
  verifyOktaAccountCreation: false,
});
const loginAuthFailure = (state, { error }) => ({
  ...state,
  loginAuthLoading: false,
  loginAuthSuccess: null,
  loginAuthFailure: error,
  verifyOktaAccountCreation: false,
});

// proxy pdn Login

const loginWithProxyPdnLoading = (state) => ({
  ...state,
  loginWithProxyPdnLoading: true,
  loginWithProxyPdnSucess: null,
  loginWithProxyPdnFailure: null,
});

const loginWithProxyPdnSuccess = (state, { res }) => ({
  ...state,
  user: res,
  session: res,
  loginWithProxyPdnLoading: false,
  loginWithProxyPdnSucess: res,
  loginHerokuSuccess: res,
  loginWithProxyPdnFailure: null,
  proxyPdn: res,
});

const loginWithProxyPdnFailure = (state, { error }) => ({
  ...state,
  loginWithProxyPdnLoading: false,
  loginWithProxyPdnSucess: null,
  loginWithProxyPdnFailure: error,
});

//

const loginTokenExchangeLoading = (state) => ({
  ...state,
  loginTokenExchangeLoading: true,
  loginTokenExchangeSuccess: null,
  loginTokenExchangeFailure: null,
});

const loginTokenExchangeSuccess = (state, { res }) => ({
  ...state,
  tokens: res,
  loginTokenExchangeLoading: false,
  loginTokenExchangeSuccess: res,
  loginTokenExchangeFailure: null,
});
const loginTokenExchangeFailure = (state, { error }) => ({
  ...state,
  loginTokenExchangeLoading: false,
  loginTokenExchangeSuccess: null,
  loginTokenExchangeFailure: error,
});

const setupBiometricsConsent = (state, { res }) => ({
  ...state,
  setupBiometricsConsent: res,
});

const loginWithTokenLoading = (state) => ({
  ...state,
  loginWithTokenLoading: true,
});
const loginWithTokenSuccess = (state, { res }) => ({
  ...state,
  tokens: res,
  loginWithTokenLoading: false,
});
const loginWithTokenFailure = (state, { error }) => ({
  ...state,
  loginWithTokenLoading: false,
});

//
const loginHeroku = (state, { id_token }) => ({
  ...state,
  token: id_token,
});

const loginHerokuLoading = (state) => ({
  ...state,
  loginHerokuLoading: true,
  loginHerokuSuccess: null,
  loginHerokuFailure: null,
});

const loginHerokuSuccess = (state, { res }) => {
  // alert('herou login success reducer -- ' + JSON.stringify(res))
  return {
    ...state,
    user: res,
    session: res,
    userRole: res.role,
    loginHerokuLoading: false,
    loginHerokuSuccess: res,
    loginHerokuFailure: null,
    loginTimeStamp: +new Date(),
    logoutTimeout: false,
  };
};
const loginHerokuFailure = (state, { error }) => ({
  ...state,
  loginHerokuLoading: false,
  loginHerokuSuccess: null,
  loginHerokuFailure: error,
});

const logoutLoading = (state) => ({
  ...state,
  logoutLoading: true,
  logoutSuccess: null,
  logoutFailure: null,
});

const logoutSuccess = (state, { res }) => ({
  ...state,
  user: null,
  session: null,
  token: null,
  tokens: null,
  loginSuccess: null,
  loginAuthSuccess: null,
  loginHerokuSuccess: null,
  loginTokenExchangeSuccess: null,
  logoutLoading: false,
  logoutSuccess: res,
  logoutFailure: null,
  loginTimeStamp: null,
  getSessionSuccess: null,
  getSessionUserSuccess: null,
  sessionRefreshSuccess: null,
});

const logoutFailure = (state, { error }) => ({
  ...state,
  logoutLoading: false,
  logoutSuccess: null,
  logoutFailure: error,
});

const logoutTimeout = (state) => ({
  ...state,
  logoutTimeout: true,
});

/* GET SESSION */

const getSessionLoading = (state) => ({
  ...state,
  getSessionLoading: true,
  getSessionSuccess: null,
  getSessionFailure: null,
});
const getSessionSuccess = (state, { res }) => ({
  ...state,
  session: res,
  getSessionLoading: false,
  getSessionSuccess: res,
  getSessionFailure: null,
});
const getSessionFailure = (state, { error }) => ({
  ...state,
  user: null,
  session: null,
  getSessionLoading: false,
  getSessionSuccess: null,
  getSessionFailure: error,
});

/* GET USER FROM SESSION */

const getSessionUserLoading = (state) => ({
  ...state,
  getSessionUserLoading: true,
  getSessionUserSuccess: null,
  getSessionUserFailure: null,
});
const getSessionUserSuccess = (state, { res }) => ({
  ...state,
  getSessionUserLoading: false,
  getSessionUserSuccess: res,
  getSessionUserFailure: null,
});
const getSessionUserFailure = (state, { error }) => ({
  ...state,
  getSessionUserLoading: false,
  getSessionUserSuccess: null,
  getSessionUserFailure: error,
});

/* GET USER FROM SESSION */

const getLoggedInUserLoading = (state) => ({
  ...state,
  getLoggedInUserLoading: true,
  getLoggedInUserSuccess: null,
  getLoggedInUserFailure: null,
});
const getLoggedInUserSuccess = (state, { res }) => ({
  ...state,
  session: res,
  getLoggedInUserLoading: false,
  getLoggedInUserSuccess: res,
  getLoggedInUserFailure: null,
});
const getLoggedInUserFailure = (state, { error }) => ({
  ...state,
  session: null,
  getLoggedInUserLoading: false,
  getLoggedInUserSuccess: null,
  getLoggedInUserFailure: error,
});

/* CONTINUE SESSION */

const sessionRefreshLoading = (state) => ({
  ...state,
  sessionRefreshLoading: true,
  sessionRefreshSuccess: null,
  sessionRefreshFailure: null,
});
const sessionRefreshSuccess = (state, { res }) => ({
  ...state,
  sessionRefreshLoading: false,
  sessionRefreshSuccess: res,
  sessionRefreshFailure: null,
});
const sessionRefreshFailure = (state, { error }) => ({
  ...state,
  sessionRefreshLoading: false,
  sessionRefreshSuccess: null,
  sessionRefreshFailure: error,
});

/* VERIFY EMAIL */

const verifyEmailLoading = (state) => ({
  ...state,
  verifyEmailLoading: true,
  verifyEmailSuccess: null,
  verifyEmailFailure: null,
});

const verifyEmailSuccess = (state, { res }) => ({
  ...state,
  verifyEmailLoading: false,
  verifyEmailSuccess: res,
  verifyEmailFailure: null,
});

const verifyEmailFailure = (state, { error }) => ({
  ...state,
  verifyEmailLoading: false,
  verifyEmailSuccess: null,
  verifyEmailFailure: error,
});

const changeDefaultCenterLoading = (state) => ({
  ...state,
  changeDefaultCenterLoading: true,
  changeDefaultCenterSuccess: null,
  changeDefaultCenterFailure: null,
});

const changeDefaultCenterSuccess = (state, { res }) => ({
  ...state,
  changeDefaultCenterLoading: false,
  changeDefaultCenterSuccess: res,
  changeDefaultCenterFailure: null,
});

const changeDefaultCenterFailure = (state, { error }) => ({
  ...state,
  changeDefaultCenterLoading: false,
  changeDefaultCenterSuccess: null,
  changeDefaultCenterFailure: error,
});

const updateAccountSettingLoading = (state) => ({
  ...state,
  updateAccountSettingLoading: true,
  updateAccountSettingSuccess: null,
  updateAccountSettingFailure: null,
});

const updateAccountSettingSuccess = (state, { res }) => ({
  ...state,
  updateAccountSettingLoading: false,
  updateAccountSettingSuccess: res,
  updateAccountSettingFailure: null,
});

const updateAccountSettingFailure = (state, { error }) => ({
  ...state,
  updateAccountSettingLoading: false,
  updateAccountSettingSuccess: null,
  updateAccountSettingFailure: error,
});

const mergeAccountSettingLoading = (state) => ({
  ...state,
  mergeAccountSettingLoading: true,
  mergeAccountSettingSuccess: null,
  mergeAccountSettingFailure: null,
});

const mergeAccountSettingSuccess = (state, { res }) => ({
  ...state,
  mergeAccountSettingLoading: false,
  mergeAccountSettingSuccess: res,
  mergeAccountSettingFailure: null,
});

const mergeAccountSettingFailure = (state, { error }) => ({
  ...state,
  mergeAccountSettingLoading: false,
  mergeAccountSettingSuccess: null,
  mergeAccountSettingFailure: error,
});

const resendVerificationLoading = (state) => ({
  ...state,
  resendVerificationLoading: true,
  resendVerificationSuccess: null,
  resendVerificationFailure: null,
});

const resendVerificationSuccess = (state, { res }) => ({
  ...state,
  resendVerificationLoading: false,
  resendVerificationSuccess: res,
  resendVerificationFailure: null,
});

const resendVerificationFailure = (state, { error }) => ({
  ...state,
  resendVerificationLoading: false,
  resendVerificationSuccess: null,
  resendVerificationFailure: error,
});

const setupNewPasswordLoading = (state) => ({
  ...state,
  setupNewPasswordLoading: true,
  setupNewPasswordSuccess: null,
  setupNewPasswordFailure: null,
});

const setupNewPasswordSuccess = (state, { res }) => ({
  ...state,
  setupNewPasswordLoading: false,
  setupNewPasswordSuccess: res,
  setupNewPasswordFailure: null,
});

const setupNewPasswordFailure = (state, { error }) => ({
  ...state,
  setupNewPasswordLoading: false,
  setupNewPasswordSuccess: null,
  setupNewPasswordFailure: error,
});

const changePasswordLoading = (state) => ({
  ...state,
  changePasswordLoading: true,
  changePasswordSuccess: null,
  changePasswordFailure: null,
});

const changePasswordSuccess = (state, { res }) => ({
  ...state,
  changePasswordLoading: false,
  changePasswordSuccess: res,
  changePasswordFailure: null,
});

const changePasswordFailure = (state, { error }) => ({
  ...state,
  changePasswordLoading: false,
  changePasswordSuccess: null,
  changePasswordFailure: error,
});

const emailLoginLoading = (state) => ({
  ...state,
  emailLoginLoading: true,
  emailLoginSuccess: null,
  emailLoginFailure: null,
});

const emailLoginSuccess = (state, { res }) => ({
  ...state,
  emailLoginLoading: false,
  emailLoginSuccess: res,
  emailLoginFailure: null,
});

const emailLoginFailure = (state, { error }) => ({
  ...state,
  emailLoginLoading: false,
  emailLoginSuccess: null,
  emailLoginFailure: error,
});

const socialLoginLoading = (state) => ({
  ...state,
  socialLoginLoading: true,
  socialLoginSuccess: null,
  socialLoginFailure: null,
});

const socialLoginSuccess = (state, { res }) => ({
  ...state,
  socialLoginLoading: false,
  socialLoginSuccess: res,
  socialLoginFailure: null,
});

const socialLoginFailure = (state, { error }) => ({
  ...state,
  socialLoginLoading: false,
  socialLoginSuccess: null,
  socialLoginFailure: error,
});

/* RESET PASSWORD */

const resetPasswordLoading = (state) => ({
  ...state,
  resetPasswordLoading: true,
  resetPasswordSuccess: null,
  resetPasswordFailure: null,
});

const resetPasswordSuccess = (state, { res }) => ({
  ...state,
  resetPasswordLoading: false,
  resetPasswordSuccess: res,
  resetPasswordFailure: null,
});

const resetPasswordFailure = (state, { error }) => ({
  ...state,
  resetPasswordLoading: false,
  resetPasswordSuccess: null,
  resetPasswordFailure: error,
});

const resetPassword2Loading = (state) => ({
  ...state,
  resetPassword2Loading: true,
  resetPassword2Success: null,
  resetPassword2Failure: null,
});

const resetPassword2Success = (state, { res }) => ({
  ...state,
  resetPassword2Loading: false,
  resetPassword2Success: res,
  resetPassword2Failure: null,
});

const resetPassword2Failure = (state, { error }) => ({
  ...state,
  resetPassword2Loading: false,
  resetPassword2Success: null,
  resetPassword2Failure: error,
});

const resetPassword3Loading = (state) => ({
  ...state,
  resetPassword3Loading: true,
  resetPassword3Success: null,
  resetPassword3Failure: null,
});

const resetPassword3Success = (state, { res }) => ({
  ...state,
  resetPassword3Loading: false,
  resetPassword3Success: res,
  resetPassword3Failure: null,
});

const resetPassword3Failure = (state, { error }) => ({
  ...state,
  resetPassword3Loading: false,
  resetPassword3Success: null,
  resetPassword3Failure: error,
});

const registerLoading = (state) => ({
  ...state,
  registerLoading: true,
  registerSuccess: null,
  registerFailure: null,
});
const registerSuccess = (state, { res }) => ({
  ...state,
  registerLoading: false,
  registerSuccess: res,
  registerFailure: null,
});
const registerFailure = (state, { error }) => ({
  ...state,
  registerLoading: false,
  registerSuccess: null,
  registerFailure: error,
});

const saveSignUp = (state, { user }) => ({
  ...state,
  registerSignUp: user,
});
const saveCreateProfile = (state, { profile }) => ({
  ...state,
  registerCreateProfile: profile,
});

const clearMigrationValues = (state) => ({
  ...state,
  socialLoginSuccess: null,
  emailLoginSuccess: null,
  changePasswordSuccess: null,
});

const cleanUserState = (state) => ({
  ...state,
  user: null,
  session: null,
  loginHerokuSuccess: null,
  userNotifications: null,
});

const userNotifications = (state, { res }) => ({
  ...state,
  userNotifications: res,
});

// MFA

const enrollMfaLoading = (state) => ({
  ...state,
  enrollMfaLoading: true,
  enrollMfaSuccess: null,
  enrollMfaFailure: null,
});

const enrollMfaSuccess = (state, { res }) => ({
  ...state,
  enrollMfaLoading: false,
  enrollMfaSuccess: res,
  enrollMfaFailure: null,
});

const enrollMfaFailure = (state, { error }) => ({
  ...state,
  enrollMfaLoading: false,
  enrollMfaSuccess: null,
  enrollMfaFailure: error,
});

const resendEnrollMfaCodeLoading = (state) => ({
  ...state,
  resendEnrollMfaCodeLoading: true,
  resendEnrollMfaCodeSuccess: null,
  resendEnrollMfaCodeFailure: null,
});

const resendEnrollMfaCodeSuccess = (state, { res }) => ({
  ...state,
  resendEnrollMfaCodeLoading: false,
  resendEnrollMfaCodeSuccess: res,
  resendEnrollMfaCodeFailure: null,
});

const resendEnrollMfaCodeFailure = (state, { error }) => ({
  ...state,
  resendEnrollMfaCodeLoading: false,
  resendEnrollMfaCodeSuccess: null,
  resendEnrollMfaCodeFailure: error,
});

const sendMfaCodeLoading = (state) => ({
  ...state,
  sendMfaCodeLoading: true,
  sendMfaCodeSuccess: null,
  sendMfaCodeFailure: null,
});

const sendMfaCodeSuccess = (state, { res }) => ({
  ...state,
  sendMfaCodeLoading: false,
  sendMfaCodeSuccess: res,
  sendMfaCodeFailure: null,
});

const sendMfaCodeFailure = (state, { error }) => ({
  ...state,
  sendMfaCodeLoading: false,
  sendMfaCodeSuccess: null,
  sendMfaCodeFailure: error,
});

const verifyMfaCodeLoading = (state) => ({
  ...state,
  verifyMfaCodeLoading: true,
  verifyMfaCodeSuccess: null,
  verifyMfaCodeFailure: null,
});

const verifyMfaCodeSuccess = (state, { res }) => ({
  ...state,
  verifyMfaCodeLoading: false,
  verifyMfaCodeSuccess: res,
  verifyMfaCodeFailure: null,
});

const verifyMfaCodeFailure = (state, { error }) => ({
  ...state,
  verifyMfaCodeLoading: false,
  verifyMfaCodeSuccess: null,
  verifyMfaCodeFailure: error,
});

const getEnrolledMfaListLoading = (state) => ({
  ...state,
  getEnrolledMfaListLoading: true,
  getEnrolledMfaListSuccess: null,
  getEnrolledMfaListFailure: null,
});

const getEnrolledMfaListSuccess = (state, { res }) => ({
  ...state,
  getEnrolledMfaListLoading: false,
  getEnrolledMfaListSuccess: res,
  getEnrolledMfaListFailure: null,
});

const getEnrolledMfaListFailure = (state, { error }) => ({
  ...state,
  getEnrolledMfaListLoading: false,
  getEnrolledMfaListSuccess: null,
  getEnrolledMfaListFailure: error,
});

const authenticateMfaCodeLoading = (state) => ({
  ...state,
  authenticateMfaCodeLoading: true,
  authenticateMfaCodeSuccess: null,
  authenticateMfaCodeFailure: null,
});

const authenticateMfaCodeSuccess = (state, { res }) => ({
  ...state,
  authenticateMfaCodeLoading: false,
  authenticateMfaCodeSuccess: res,
  authenticateMfaCodeFailure: null,
});

const authenticateMfaCodeFailure = (state, { error }) => ({
  ...state,
  authenticateMfaCodeLoading: false,
  authenticateMfaCodeSuccess: null,
  authenticateMfaCodeFailure: error,
});

export const reducer = createReducer(INITIAL_STATE, {
  [UsersTypes.LOGIN_LOADING]: loginLoading,
  [UsersTypes.LOGIN_SUCCESS]: loginSuccess,
  [UsersTypes.LOGIN_FAILURE]: loginFailure,

  [UsersTypes.LOGIN_AUTH_LOADING]: loginAuthLoading,
  [UsersTypes.LOGIN_AUTH_SUCCESS]: loginAuthSuccess,
  [UsersTypes.LOGIN_AUTH_FAILURE]: loginAuthFailure,

  [UsersTypes.LOGIN_HEROKU]: loginHeroku,
  [UsersTypes.LOGIN_HEROKU_LOADING]: loginHerokuLoading,
  [UsersTypes.LOGIN_HEROKU_SUCCESS]: loginHerokuSuccess,
  [UsersTypes.LOGIN_HEROKU_FAILURE]: loginHerokuFailure,

  [UsersTypes.SETUP_BIOMETRICS_CONSENT]: setupBiometricsConsent,

  [UsersTypes.LOGIN_WITH_TOKEN_LOADING]: loginWithTokenLoading,
  [UsersTypes.LOGIN_WITH_TOKEN_SUCCESS]: loginWithTokenSuccess,
  [UsersTypes.LOGIN_WITH_TOKEN_FAILURE]: loginWithTokenFailure,

  [UsersTypes.LOGIN_TOKEN_EXCHANGE_LOADING]: loginTokenExchangeLoading,
  [UsersTypes.LOGIN_TOKEN_EXCHANGE_SUCCESS]: loginTokenExchangeSuccess,
  [UsersTypes.LOGIN_TOKEN_EXCHANGE_FAILURE]: loginTokenExchangeFailure,

  [UsersTypes.LOGIN_WITH_PROXY_PDN_LOADING]: loginWithProxyPdnLoading,
  [UsersTypes.LOGIN_WITH_PROXY_PDN_SUCCESS]: loginWithProxyPdnSuccess,
  [UsersTypes.LOGIN_WITH_PROXY_PDN_FAILURE]: loginWithProxyPdnFailure,

  [UsersTypes.REGISTER_LOADING]: registerLoading,
  [UsersTypes.REGISTER_SUCCESS]: registerSuccess,
  [UsersTypes.REGISTER_FAILURE]: registerFailure,

  [UsersTypes.SAVE_SIGN_UP]: saveSignUp,
  [UsersTypes.SAVE_CREATE_PROFILE]: saveCreateProfile,

  [UsersTypes.LOGOUT_LOADING]: logoutLoading,
  [UsersTypes.LOGOUT_SUCCESS]: logoutSuccess,
  [UsersTypes.LOGOUT_FAILURE]: logoutFailure,
  [UsersTypes.LOGOUT_TIMEOUT]: logoutTimeout,

  [UsersTypes.GET_SESSION_LOADING]: getSessionLoading,
  [UsersTypes.GET_SESSION_SUCCESS]: getSessionSuccess,
  [UsersTypes.GET_SESSION_FAILURE]: getSessionFailure,

  [UsersTypes.GET_SESSION_USER_LOADING]: getSessionUserLoading,
  [UsersTypes.GET_SESSION_USER_SUCCESS]: getSessionUserSuccess,
  [UsersTypes.GET_SESSION_USER_FAILURE]: getSessionUserFailure,

  [UsersTypes.GET_LOGGED_IN_USER_LOADING]: getLoggedInUserLoading,
  [UsersTypes.GET_LOGGED_IN_USER_SUCCESS]: getLoggedInUserSuccess,
  [UsersTypes.GET_LOGGED_IN_USER_FAILURE]: getLoggedInUserFailure,

  [UsersTypes.VERIFY_EMAIL_LOADING]: verifyEmailLoading,
  [UsersTypes.VERIFY_EMAIL_SUCCESS]: verifyEmailSuccess,
  [UsersTypes.VERIFY_EMAIL_FAILURE]: verifyEmailFailure,

  [UsersTypes.CHANGE_DEFAULT_CENTER_LOADING]: changeDefaultCenterLoading,
  [UsersTypes.CHANGE_DEFAULT_CENTER_SUCCESS]: changeDefaultCenterSuccess,
  [UsersTypes.CHANGE_DEFAULT_CENTER_FAILURE]: changeDefaultCenterFailure,

  [UsersTypes.UPDATE_ACCOUNT_SETTING_LOADING]: updateAccountSettingLoading,
  [UsersTypes.UPDATE_ACCOUNT_SETTING_SUCCESS]: updateAccountSettingSuccess,
  [UsersTypes.UPDATE_ACCOUNT_SETTING_FAILURE]: updateAccountSettingFailure,

  [UsersTypes.MERGE_ACCOUNT_SETTING_LOADING]: mergeAccountSettingLoading,
  [UsersTypes.MERGE_ACCOUNT_SETTING_SUCCESS]: mergeAccountSettingSuccess,
  [UsersTypes.MERGE_ACCOUNT_SETTING_FAILURE]: mergeAccountSettingFailure,

  [UsersTypes.RESEND_VERIFICATION_LOADING]: resendVerificationLoading,
  [UsersTypes.RESEND_VERIFICATION_SUCCESS]: resendVerificationSuccess,
  [UsersTypes.RESEND_VERIFICATION_FAILURE]: resendVerificationFailure,

  [UsersTypes.SETUP_NEW_PASSWORD_LOADING]: setupNewPasswordLoading,
  [UsersTypes.SETUP_NEW_PASSWORD_SUCCESS]: setupNewPasswordSuccess,
  [UsersTypes.SETUP_NEW_PASSWORD_FAILURE]: setupNewPasswordFailure,

  [UsersTypes.RESET_PASSWORD_LOADING]: resetPasswordLoading,
  [UsersTypes.RESET_PASSWORD_SUCCESS]: resetPasswordSuccess,
  [UsersTypes.RESET_PASSWORD_FAILURE]: resetPasswordFailure,

  [UsersTypes.RESET_PASSWORD2_LOADING]: resetPassword2Loading,
  [UsersTypes.RESET_PASSWORD2_SUCCESS]: resetPassword2Success,
  [UsersTypes.RESET_PASSWORD2_FAILURE]: resetPassword2Failure,

  [UsersTypes.RESET_PASSWORD3_LOADING]: resetPassword3Loading,
  [UsersTypes.RESET_PASSWORD3_SUCCESS]: resetPassword3Success,
  [UsersTypes.RESET_PASSWORD3_FAILURE]: resetPassword3Failure,

  [UsersTypes.SESSION_REFRESH_LOADING]: sessionRefreshLoading,
  [UsersTypes.SESSION_REFRESH_SUCCESS]: sessionRefreshSuccess,
  [UsersTypes.SESSION_REFRESH_FAILURE]: sessionRefreshFailure,

  [UsersTypes.VERIFY_OKTA_ACCOUNT_LOADING]: verifyOktaAccountLoading,
  [UsersTypes.VERIFY_OKTA_ACCOUNT_SUCCESS]: verifyOktaAccountSuccess,
  [UsersTypes.VERIFY_OKTA_ACCOUNT_FAILURE]: verifyOktaAccountFailure,

  [UsersTypes.CHANGE_PASSWORD_LOADING]: changePasswordLoading,
  [UsersTypes.CHANGE_PASSWORD_SUCCESS]: changePasswordSuccess,
  [UsersTypes.CHANGE_PASSWORD_FAILURE]: changePasswordFailure,

  [UsersTypes.EMAIL_LOGIN_LOADING]: emailLoginLoading,
  [UsersTypes.EMAIL_LOGIN_SUCCESS]: emailLoginSuccess,
  [UsersTypes.EMAIL_LOGIN_FAILURE]: emailLoginFailure,

  [UsersTypes.SOCIAL_LOGIN_LOADING]: socialLoginLoading,
  [UsersTypes.SOCIAL_LOGIN_SUCCESS]: socialLoginSuccess,
  [UsersTypes.SOCIAL_LOGIN_FAILURE]: socialLoginFailure,

  [UsersTypes.CLEAR_MIGRATION_VALUES]: clearMigrationValues,
  [UsersTypes.CLEAN_USER_STATE]: cleanUserState,

  [UsersTypes.USER_NOTIFICATIONS]: userNotifications,

  [UsersTypes.ENROLL_MFA_LOADING]: enrollMfaLoading,
  [UsersTypes.ENROLL_MFA_SUCCESS]: enrollMfaSuccess,
  [UsersTypes.ENROLL_MFA_FAILURE]: enrollMfaFailure,

  [UsersTypes.SEND_MFA_CODE_LOADING]: sendMfaCodeLoading,
  [UsersTypes.SEND_MFA_CODE_SUCCESS]: sendMfaCodeSuccess,
  [UsersTypes.SEND_MFA_CODE_FAILURE]: sendMfaCodeFailure,

  [UsersTypes.VERIFY_MFA_CODE_LOADING]: verifyMfaCodeLoading,
  [UsersTypes.VERIFY_MFA_CODE_SUCCESS]: verifyMfaCodeSuccess,
  [UsersTypes.VERIFY_MFA_CODE_FAILURE]: verifyMfaCodeFailure,

  [UsersTypes.RESEND_ENROLL_MFA_CODE_LOADING]: resendEnrollMfaCodeLoading,
  [UsersTypes.RESEND_ENROLL_MFA_CODE_SUCCESS]: resendEnrollMfaCodeSuccess,
  [UsersTypes.RESEND_ENROLL_MFA_CODE_FAILURE]: resendEnrollMfaCodeFailure,

  [UsersTypes.GET_ENROLLED_MFA_LIST_LOADING]: getEnrolledMfaListLoading,
  [UsersTypes.GET_ENROLLED_MFA_LIST_SUCCESS]: getEnrolledMfaListSuccess,
  [UsersTypes.GET_ENROLLED_MFA_LIST_FAILURE]: getEnrolledMfaListFailure,

  [UsersTypes.AUTHENTICATE_MFA_CODE_LOADING]: authenticateMfaCodeLoading,
  [UsersTypes.AUTHENTICATE_MFA_CODE_SUCCESS]: authenticateMfaCodeSuccess,
  [UsersTypes.AUTHENTICATE_MFA_CODE_FAILURE]: authenticateMfaCodeFailure,
});
